<template>
  <v-tooltip bottom :disabled="disabled" content-class="custom-tooltip">
    <template v-slot:activator="{ on }">
      <span v-on="on">
        <slot />
      </span>
    </template>
    <span class="no-print" v-html="text" />
  </v-tooltip>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  components: {}
})
export default class Tooltip extends Vue {
  @Prop()
  text!: string;

  @Prop({ default: false })
  disabled!: boolean;
}
</script>

<style scoped>
@media print {
  .no-print,
  .no-print * {
    display: none !important;
  }
}

.custom-tooltip .no-print {
  max-width: 400px !important;
  white-space: pre-line !important;
  word-wrap: break-word !important;
  display: block !important;
}
</style>
